
import { Component } from "vue-property-decorator";
import news from "@/views/kaizhou-shuai-video/news.vue";

@Component({
  name: "videoNews"
})
export default class videoNews extends news {}
